import React from "react";
import Heading from "../../components/heading/heading";
import ProfilePhotos from "../../components/profile-photos/profile-photos";
import ProfileMenu from "../../components/profile-menu/profile-menu";



export function ProfilePhotosPage({ withProfileMenu = false }) {
    const fromShow = withProfileMenu ? 'profile' : 'rega';
    return (
        <>
            {withProfileMenu && <ProfileMenu />}
            {!withProfileMenu && (<Heading tpl="new">Мои <span className="my-text-primary">фото</span></Heading>)}
            <ProfilePhotos fromShow={fromShow} />
        </>
    );
}

